/**
 * OpenList 树视图组件
 */

"use client"

import { Folder } from "lucide-react"
import type { OpenListTreeNode } from "@/types/openlist"
import { OpenListTreeNode as TreeNodeComponent } from "./openlist-tree-node"

interface OpenListTreeViewProps {
  treeNodes: OpenListTreeNode[]
  expandedFolders: Set<string>
  loadingNodes: Set<string>
  clickedFileId: string | null
  isDownloading: Set<string>
  onToggleFolder: (node: OpenListTreeNode) => void
  onPreview: (file: any) => void
  onDownload: (file: any) => void
}

export function OpenListTreeView({
  treeNodes,
  expandedFolders,
  loadingNodes,
  clickedFileId,
  isDownloading,
  onToggleFolder,
  onPreview,
  onDownload
}: OpenListTreeViewProps) {
  if (treeNodes.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <Folder className="h-16 w-16 mx-auto mb-4 text-gray-300" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">暂无文件</h3>
        <p className="text-gray-600">当前科目下没有文件或文件夹</p>
      </div>
    )
  }

  return (
    <div className="space-y-1">
      {treeNodes.map(node => (
        <TreeNodeComponent
          key={node.id}
          node={node}
          expandedFolders={expandedFolders}
          loadingNodes={loadingNodes}
          clickedFileId={clickedFileId}
          isDownloading={isDownloading}
          onToggleFolder={onToggleFolder}
          onPreview={onPreview}
          onDownload={onDownload}
        />
      ))}
    </div>
  )
}
